import React from 'react';
import { Button } from '@roger/ui-components';
import { useNavigate } from 'react-router-dom';
import Stedi_COB_Testing from '../components/Stedi_COB_Testing';

const TestingStedi_COB: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className='container mx-auto p-6 space-y-6'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center space-x-4'>
          <Button
            variant='outline'
            onClick={() => navigate('/testing')}
            className='flex items-center space-x-2'
          >
            <span>←</span>
            <span>Back to Testing</span>
          </Button>
          <div>
            <h1 className='text-3xl font-bold'>Stedi COB Testing</h1>
            <p className='text-muted-foreground'>
              Test coordination of benefits (COB) using Stedi’s JSON API format
            </p>
          </div>
        </div>
      </div>

      <Stedi_COB_Testing />
    </div>
  );
};

export default TestingStedi_COB;
